<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/jinjiang/16/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/14/title-1.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）全日制应届博士研究生、创业人才；
            </div>
          </div>
          <div class="content">
            <div class="font">（二）引进全日制应届硕士研究生。</div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-2.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）全日制应届硕士研究生：满足锦江区人才需求清单或当年《锦江区人才开发指引》紧缺度3星岗位要求（创业人才不受此限制）。所在企业在锦江区依法登记、具有独立法人资格，工商关系和税收关系在锦江区，属于锦江区“1+3+3”现代产业体系发展方向，且为锦江区区经济社会做出重大贡献（“规上”入库企业或年度经济贡献度100万元以上企业或年度营业〈产值〉2000万元以上企业或国家高新技术企业或“专精特新”企业，全日制应届博士研究生、创业人才不受此限制）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）创业人才：全日制应届研究生作为主要创始人（持股比例不少于30%）来锦江创办“1+3+3”产业领域企业的，所创办企业实收资本中货币出资不得低于50万元。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/15/title-3.png"
            alt=""
          />
          <div class="content">
            对新引进全日制应届博士、硕士研究生，从引进的次月起3年内，分别给予1500元/人/月、1000元/人/月的生活补贴。
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/3/title-4.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区企业新引进全日制研究生生活补贴申请表》；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申报企业统一社会信用代码证复印件、年度纳税证明；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）引进人才的身份证（护照）复印件，毕业证书、学位证书复印件，社保缴纳证明、个税缴纳证明；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （四）引进人才与企业签订的正式劳动（聘用）合同复印件（签订单位须与社会保险参保单位一致）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （五）行业主管部门认定企业为锦江经济社会做出重大贡献的证明材料（全日制应届博士研究生无须提供）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （六）创业人才还需提供所创办企业的相关证明材料，包括但不限于加盖工商鲜章的公司章程、商业计划书、盖有会计师事务所公章的公司验资报告或审计报告（资产负债表）、上年度企业财务报表等。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-5.png"
            alt=""
          />
          <div class="content" style="font-weight: 600">
            符合条件的人才由所在企业向锦江区人社局提出申请。
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-6.png"
            alt=""
          />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86511559">028-86511559</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              锦江区人社局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 50%;
  border: 0.08rem solid #ff6d60;
  flex-shrink: 0;
  margin-right: 0.1rem;
  margin-top: 0.05rem;
}
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 100%;
    height: auto;
  }
  .technological-process {
    transform: translateY(-2.2rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.35rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.3rem 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/jinjiang/1/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
